/* eslint-disable no-underscore-dangle */
/* eslint-disable no-invalid-this */
import React from "react";
import { rhythm } from "../../utils/typography";
import addToMailchimp from "gatsby-plugin-mailchimp";

import styles from "./emailform.module.css";

class EmailCaptureForm extends React.Component {
  constructor() {
    super();
    this.state = { email: `` };
  }

  // Update state each time user edits their email address
  _handleEmailChange = e => {
    this.setState({ email: e.target.value });
  };

  _validateEmail = email => {
    // eslint-disable-next-line no-useless-escape
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return re.test(email);
  };

  // Post to MC server & handle its response
  _postEmailToMailchimp = (email, attributes) => {
    addToMailchimp(email, attributes)
      .then(result => {

        /*
         * Mailchimp always returns a 200 response
         * So we check the result for MC errors & failures
         */
        if (result.result === `success`) {
          // Email address succesfully subcribed to Mailchimp
          this.setState({
            status: `success`,
            msg: result.msg
          });
        } else {
          this.setState({
            status: `error`,
            msg: result.msg
          });
        }
      })
      .catch(err => {
        // Network failures, timeouts, etc
        this.setState({
          status: `error`,
          msg: err
        });
      });
  };

  // eslint-disable-next-line consistent-return
  _handleFormSubmit = e => {
    e.preventDefault();
    e.stopPropagation();

    if (!this._validateEmail(this.state.email)) {
      this.setState({
        status: `error`,
        msg: `Please enter a valid email address.`
      });
      return false;
    }

    this.setState(
      {
        status: `sending`,
        msg: null
      },
      // SetState callback (subscribe email to MC)
      // eslint-disable-next-line no-underscore-dangle
      this._postEmailToMailchimp(this.state.email, { pathname: document.location.pathname })
    );
  };

  render() {
    return (
      <div className="container" style={{ paddingTop: rhythm(1.5) }}>
        {this.state.status === `success`
          ? <div style={{ paddingBottom: rhythm(1.5) }}>
            Thank you!<br />You are now subscribed to the newsletter.
          </div>
         : <div className={styles.formContainer}>
            <div className={styles.leftCol}>
              <h2 style={{ marginBottom: rhythm(0.5) }}>
                Join the mailing list
              </h2>
              <p>Sign up for updates on new training courses and blog posts.</p>
            </div>
            <form
              id="email-capture"
              method="post"
              noValidate
              className={styles.rightCol}
            >
              <input
                className={styles.input}
                type="email"
                name="email"
                placeholder="you@email.com"
                onChange={this._handleEmailChange}
              />
              <button
                className={styles.button}
                type="submit"
                onClick={this._handleFormSubmit}
              >
                Subscribe
              </button>
              {this.state.status === `error` &&
                <div
                  dangerouslySetInnerHTML={{ __html: this.state.msg }}
                  style={{ marginTop: rhythm(0.5) }}
                />
              }
            </form>
            <div className="cl" />
          </div>
        }
      </div>
    );
  }
}

export default EmailCaptureForm;



// WEBPACK FOOTER //
// ./src/components/EmailForm/index.jsx